/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { VerifyLoginOptions, VerifyLoginResponses } from '../models/VerifyLogin'
import { client } from '#shared/api/client'

/**
 * @summary A finished login signs the account in: the response sets the session
 * cookie alongside the body.
 * {@link /api/webauthn/verify-login}
 */
export function verifyLogin<ThrowOnError extends boolean = true>(options: Options<VerifyLoginOptions, ThrowOnError>): Promise<RequestResult<VerifyLoginResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/webauthn/verify-login', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<VerifyLoginResponses, ThrowOnError>>
}
